function getCaptionValue(property, includeContext) {
  if (!property) {
    return void 0;
  }
  if (property.showInContext && ["in-context", "both"].includes(includeContext)) {
    return property.value;
  }
  if (property.showOutsideContext && ["outside-context", "both"].includes(includeContext)) {
    return property.value;
  }
}

export { getCaptionValue };
//# sourceMappingURL=typings.component-caption.js.map
